module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readLocalFileShow),
      expression: "readLocalFileShow"
    }],
    staticClass: "read-local-file"
  }, [_c('div', {
    staticClass: "info-wraper"
  }, [(!_vm.isMobile) ? _c('h3', [_vm._v("拖拽 .md 扩展名文件到此处加载")]) : _vm._e(), _c('label', {
    staticClass: "add-icon",
    attrs: {
      "title": "打开一个markdown文件"
    }
  }, [_vm._v("+"), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.openFile
    }
  })])]), _c('a', {
    staticClass: "cancel-import",
    on: {
      "click": _vm.cancelImport
    }
  }, [_vm._v("×")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0a6b9e24"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markdown-input/read-local-file/read-local-file.vue
// module id = 276
// module chunks = 1